import { Component, OnInit } from "@angular/core";
import { FormControl, UntypedFormBuilder } from "@angular/forms";
import {
  StringCustomFieldConfig,
  DataService,
  SharedModule,
  FormInputComponent,
  ModalService,
} from "@bb-vendure/admin-ui/core";
import {
  switchMap,
  catchError,
  debounceTime,
  distinctUntilChanged,
} from "rxjs/operators";
import { Observable, of, Subject, concat, tap, take } from "rxjs";
import {
  SortOrder,
  SplitOrderRulesDocument,
  SplitOrderRulesQuery,
} from "src/generated-gql/graphql";

export type AddArtistResult = {
  artistId: string | undefined;
};

@Component({
  selector: 'split-order-rules',
  standalone: true,
  imports: [SharedModule],
  templateUrl: "./select.component.html",
})
export class SplitOrderRuleSelectComponent
  implements FormInputComponent<StringCustomFieldConfig>, OnInit
{
  resolveWith: (result?: AddArtistResult) => void;
  constructor(
    private dataService: DataService,
    private modalService: ModalService
  ) {}

  isListInput?: boolean = false;
  readonly: boolean;
  formControl: FormControl<any>;
  config: StringCustomFieldConfig;
  rules$: Observable<SplitOrderRulesQuery["splitOrderRules"]["items"]>;
  input$ = new Subject<string>();
  isLoading = false;
  selectedArtist: any;
  ngOnInit(): void {
    this.dataService
      .query(SplitOrderRulesDocument, {
        options: {
          filter: {
            isDefault: {
              eq: true,
            },
          },
        },
      })
      .single$.subscribe(({ splitOrderRules }) => {
        if (splitOrderRules.items && !this.formControl.value) {
          this.formControl.patchValue(splitOrderRules.items[0]);
        }
      });

    this.rules$ = concat(
      this.dataService
        .query(SplitOrderRulesDocument, {
          options: {
            take: 5,
            sort: {
              createdAt: SortOrder.Desc,
            },
          },
        })
        .single$.pipe(
          switchMap(data => {
            return of(data.splitOrderRules.items);
          })
        ),
      this.input$.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap(term =>
          this.dataService
            .query(SplitOrderRulesDocument, {
              options: {
                filter:
                  term && term.length > 0
                    ? {
                        name: {
                          contains: term,
                        },
                      }
                    : undefined,
                take: 10,
                sort: {
                  createdAt: SortOrder.Desc,
                },
              },
            })
            .mapStream(({ splitOrderRules }) => splitOrderRules.items)
            .pipe(
              catchError(() => of([])), // empty list on error
              tap(() => (this.isLoading = false))
            )
        )
      )
    );
  }
  compareFn(item1: { id: string } | null, item2: { id: string } | null) {
    return item1 && item2 ? item1.id === item2.id : item1 === item2;
  }

  trackByFn(item: { id: any }) {
    return item.id;
  }
}
